import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=2474bc56&scoped=true&"
import script from "./navigator.vue?vue&type=script&lang=js&"
export * from "./navigator.vue?vue&type=script&lang=js&"
import style0 from "./navigator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./navigator.vue?vue&type=style&index=1&id=2474bc56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474bc56",
  null
  
)

export default component.exports